// 非 React 的消息通知系统（DOM 操作，不依赖 React）
// 与 antd.message API 等价：success / error / warning / info
type MessageType = 'success' | 'error' | 'warning' | 'info';

const messageContainer = document.createElement('div');
// pointer-events-none 很关键：该容器固定在右上角且带 flex 布局，
// 若允许接收指针事件，它会覆盖该区域并拦截下层的点击（即便当前没有任何消息，
// 容器本身也占据空间）。表现为"弹出提示后按钮点不动"。
// 各消息项再通过 pointer-events-auto 恢复自身的点击能力（例如关闭按钮）。
messageContainer.className =
  'fixed top-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none';
if (document.body) {
  document.body.appendChild(messageContainer);
} else {
  document.addEventListener('DOMContentLoaded', () => document.body.appendChild(messageContainer));
}

export const message = {
  success: (content: string) => showMessage(content, 'success'),
  error: (content: string) => showMessage(content, 'error'),
  warning: (content: string) => showMessage(content, 'warning'),
  info: (content: string) => showMessage(content, 'info'),
};

function showMessage(content: string, type: MessageType) {
  const id = Date.now() + Math.random();
  const bgColor: string = {
    success: 'bg-green-500/90',
    error: 'bg-red-500/90',
    warning: 'bg-yellow-500/90',
    info: 'bg-blue-500/90',
  }[type];
  const iconMap: Record<MessageType, string> = {
    success:
      '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>',
    error:
      '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>',
    warning:
      '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>',
    info: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>',
  };

  const el = document.createElement('div');
  el.id = `msg-${id}`;
  // pointer-events-auto：容器已设为 none，此处恢复消息自身的点击能力
  el.className = `${bgColor} text-white px-4 py-3 rounded-lg shadow-lg backdrop-blur-sm transform transition-all duration-300 translate-x-[120%] max-w-md pointer-events-auto`;
  el.innerHTML = `
    <div class="flex items-center gap-3">
      <span class="shrink-0">${iconMap[type]}</span>
      <span class="flex-1 text-sm">${content}</span>
      <button onclick="document.getElementById('msg-${id}').remove()" class="shrink-0 text-white/70 hover:text-white transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
      </button>
    </div>
  `;
  messageContainer.appendChild(el);
  requestAnimationFrame(() => el.classList.remove('translate-x-[120%]'));
  setTimeout(() => {
    if (el.parentNode) {
      el.classList.add('opacity-0', 'translate-x-[120%]');
      setTimeout(() => el.remove(), 300);
    }
  }, 5000);
}
